import { useState } from "react";
import { LOGO_URL } from "@/constants/network";

const USDT_LOGO = "/tokens/usdt.svg";
const SIZES = { xs: "w-4 h-4 text-[8px]", sm: "w-5 h-5 text-[10px]", md: "w-8 h-8 text-xs", lg: "w-12 h-12 text-base" };

const builtinLogo = (symbol, address) => {
  if (!address && symbol === "FMI") return LOGO_URL;
  if (symbol === "USDT" && !address) return USDT_LOGO;
  if (symbol === "FBTC" && !address) return "/tokens/fbtc.svg";
  return null;
};

/** Token logo: FMI/USDT built-ins, uploaded logos for FSC tokens, or a lettered fallback. */
export const TokenLogo = ({ address, symbol, size = "sm", version, testId }) => {
  const [failedSrc, setFailedSrc] = useState(null);
  const src = builtinLogo(symbol, address) || (address && `/api/tokens/${address}/logo${version ? `?v=${version}` : ""}`);
  const failed = failedSrc === src;
  const cls = `${SIZES[size]} rounded-full shrink-0`;
  if (src && !failed) {
    return <img data-testid={testId} src={src} alt={symbol || "token"} onError={() => setFailedSrc(src)} className={`${cls} object-cover bg-[#050505]`} />;
  }
  return (
    <span data-testid={testId} className={`${cls} inline-flex items-center justify-center font-bold bg-[#D4AF37]/15 text-[#D4AF37] border border-[#D4AF37]/30`}>
      {(symbol || "?").slice(0, 2)}
    </span>
  );
};
